// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteCustomerAddress_buttons__TQJR9","addressText":"DeleteCustomerAddress_addressText__uxhh7"};